import React, { useState, useEffect } from 'react';
import  { Container, Row, Col, Button,  Breadcrumb } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../page-layout/header/Header';
import NavMenu from '../navigation/Navmenu';
import Footer from '../page-layout/footer/Footer';
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import moment from 'moment';
import { getRoles } from '../../utils/swtAlert';
import { Decrypt } from '../../utils/Helper';
import { GrokLoading } from "../page-layout/loading/Loading";
import { GetCollegeReport } from "../../utils/axios/ReportsAPI";

const GroupByCollege = () => {
    const [userInfo, setuserInfo] = useState(JSON.parse(Decrypt(sessionStorage.getItem('userInfo'))));
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [clearRows, setClearRows] = useState(false);
    const [role, setRole] = useState('');
    
    const columns = [
        {
          name: "College Name",
          selector:  row => row.collegeName,
          sortable:true,
          cell: row => row.collegeName,
        },
        {
          name: "Total Challenge Participated",
          selector:  row => row.challengeCount,
          sortable:true,
          cell: row => row.challengeCount,
        },
        {
            name: "Participation",
            width: "150px",
            cell: (row) => (<>
                <button className="btn btn-link" title="Participant Details"><span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><circle cx="152" cy="184" r="72"></circle><path d="M234 296c-28.16-14.3-59.24-20-82-20-44.58 0-136 27.34-136 82v42h150v-16.07c0-19 8-38.05 22-53.93 11.17-12.68 26.81-24.45 46-34z"></path><path d="M340 288c-52.07 0-156 32.16-156 96v48h312v-48c0-63.84-103.93-96-156-96z"></path><circle cx="340" cy="168" r="88"></circle></svg></span></button>
            </>),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            omit: (role == "Student") ? true : false
        },
    ]
    const [data, setData] = useState();
    const tableData = {
      columns,
      data,
    };

    const BackBtn = () => {
        navigate('/home');
    }

    const addRefresh = () => {
        navigate('/home', {state: {Collegeid: null}});
    }

    const getcollegereport = async () => {
        var organizationResponse = await GetCollegeReport();
        setData(organizationResponse.data);
        setLoading(false);
        setClearRows(false);
    }

    useEffect(() => {
        getcollegereport();
        const role = getRoles(userInfo);
        setRole(role);
        setTimeout(() => {
            if(role === 'Grok Admin') { //Grok Admin
                document.getElementById('nav-dropdownReport').parentElement.classList.add('show');
                document.getElementById('nav-dropdownReport').nextSibling.classList.add('show');
            }
            else {
                // Error handler
            }
            
        }, 300);
    }, [])


    return (
        <div className='page'>
        {loading ? <GrokLoading /> : ""}
            <NavMenu />
            <Header />
            <div className='page-wrapper'>
                <Container fluid>
                    {/* Start Page Header */}
                    <div className='page-header d-print-none'>
                        <Row className='g-2 align-items-center pb-1'>
                            <div>
                                <Breadcrumb className="custom-breadcrumb">
                                    <Breadcrumb.Item onClick={() => addRefresh()}> Home</Breadcrumb.Item>
                                    <Breadcrumb.Item active> GroupByCollege</Breadcrumb.Item>
                                </Breadcrumb>
                            </div>
                            <Col style={{ display: 'flex', alignItems: 'center' }}>
                                <Button className='nave-icon' variant='outline' size='sm' title='College'>
                                    <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" aria-hidden="true" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M3 2.25a.75.75 0 000 1.5v16.5h-.75a.75.75 0 000 1.5H15v-18a.75.75 0 000-1.5H3zM6.75 19.5v-2.25a.75.75 0 01.75-.75h3a.75.75 0 01.75.75v2.25a.75.75 0 01-.75.75h-3a.75.75 0 01-.75-.75zM6 6.75A.75.75 0 016.75 6h.75a.75.75 0 010 1.5h-.75A.75.75 0 016 6.75zM6.75 9a.75.75 0 000 1.5h.75a.75.75 0 000-1.5h-.75zM6 12.75a.75.75 0 01.75-.75h.75a.75.75 0 010 1.5h-.75a.75.75 0 01-.75-.75zM10.5 6a.75.75 0 000 1.5h.75a.75.75 0 000-1.5h-.75zm-.75 3.75A.75.75 0 0110.5 9h.75a.75.75 0 010 1.5h-.75a.75.75 0 01-.75-.75zM10.5 12a.75.75 0 000 1.5h.75a.75.75 0 000-1.5h-.75zM16.5 6.75v15h5.25a.75.75 0 000-1.5H21v-12a.75.75 0 000-1.5h-4.5zm1.5 4.5a.75.75 0 01.75-.75h.008a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75h-.008a.75.75 0 01-.75-.75v-.008zm.75 2.25a.75.75 0 00-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 00.75-.75v-.008a.75.75 0 00-.75-.75h-.008zM18 17.25a.75.75 0 01.75-.75h.008a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75h-.008a.75.75 0 01-.75-.75v-.008z" clipRule="evenodd"></path></svg></span>
                                </Button>
                                <h2 className="page-title">Group By College</h2>
                            </Col>
                            <Col className="mb-1 me-3 col-md-auto">
                                <button className='newBtn_style' onClick={() => BackBtn()}>
                                    <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M249.38 336L170 256l79.38-80m-68.35 80H342"></path><path fill="none" strokeMiterlimit="10" strokeWidth="32" d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"></path></svg></span>
                                    &nbsp;&nbsp;Back
                                </button>
                            </Col>
                        </Row>
                    </div>
                    {/* End Page Header */}
                    <div className='py-3'>
                        <div className='card mb-3 mb-lg-5 '>
                            {/* Header */}
                            <div className='card-header'>
                                <Row className="row justify-content-between align-items-center flex-grow-1">
                                    <Col className='col-md mb-2 md-mb-0'>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="card-title fw-bold mb-0">Group By College list
                                        </div>
                                        </div>
                                    </Col>
                                    {/* End Col */}
                                    <Col className='col-12 col-md-auto ms-auto d-print-none'>
                                    </Col>
                                    {(role === 'Grok Admin') && <Col className='col-12 col-md-auto ms-auto d-print-none'>
                                        {/* <button className="ms-2 backBtn_style" onClick={() => addCollege()} >
                                            New College
                                        </button> */}
                                    </Col>}
                                </Row>
                                {/* End Row */}
                            </div>
                            <div className='taablist'>
                              <DataTableExtensions {...tableData}>
                                  <DataTable
                                      columns={columns}
                                      data={data}
                                      fixedHeader
                                      defaultSortField="id"
                                      defaultSortAsc={false}
                                      pagination
                                      paginationPerPage={20}
                                      paginationRowsPerPageOptions={[20, 30, 50, 100]}
                                      clearSelectedRows={clearRows}
                                  />
                              </DataTableExtensions>
                            </div>
                        </div>
                    </div>
                </Container>
                <Footer />
            </div>
        </div>
    )
}

export default GroupByCollege; 